module.exports = __webpack_public_path__ + "static/img/friendly.5face8f1.svg";